import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getSanksi = 'sanksi-anggota';
const getSanksiAnggota = 'sanksi-anggota/anggota/';
const postSanksiUrl = 'sanksi-anggota';
const deleteData = 'sanksi-anggota/';

class SanksiService {
    getSanksi(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getSanksi + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }
    getSanksiAnggota(currentPage, pageSize, filter, idUser) {
        return axios.get(
            API_URL + getSanksiAnggota + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&idUser=' + idUser ,
            {
                headers: authHeader()
            });
    }

    postDataSanksi(formSanksi) {
        return axios
            .post(
                API_URL + postSanksiUrl,
                formSanksi,
                { headers: authHeader() }
            );
    }

    deleteDataSanksi(formData) {
        return axios.delete(API_URL + deleteData + formData.id_sanksi, {
            headers: authHeader()
        });
    }

}

export default new SanksiService();